import { Record, OrderedSet } from 'immutable'

const UserPreferencesRecord = Record(
  {
    id: null,
    seenBannerDownloadDesktopApp: null, // to prevent banner blink, default is null, but hydratation by default must set false.
    featureFlags: '',
    favoriteChannelIds: OrderedSet(),
    notificationsDigestFrequency: null,
    mutedChannelIds: OrderedSet(),
    bookmarkedNoteIds: OrderedSet(),
    lastVisitedNoteIds: OrderedSet(),
    lastVisitedChannelIds: OrderedSet(),
    lastSearchedTerms: OrderedSet(),
    onboardingStep: 'done',
    isChannelOnboardingDone: false,
    lastActivityFeedViewedAt: null,
    acceptedPrivacyPolicyAt: '',
    seenNearNoteLimitIncentiveAt: null,
    closedImportContentCallToActionAt: null,
    defaultChannelsTab: [],
    onboardingChannelId: null,
    suppressedEnableApp: [],
    suppressedConnectApp: [],
    isDesktopUser: null,
    confluenceApiAuthentication: null,
    colorMode: 'system',
  },
  'userPreferences'
)

export default UserPreferencesRecord
